import { useEffect, useRef } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';

export const CreateDotaznik = (props) => {
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const didSubmit = useRef(false);

    useEffect(() => {
        if (auth.accessToken === undefined) {
            props.handler(false, "notAuth");
            return;
        }

        // guards against React StrictMode's dev-only double effect invocation
        // (mount -> cleanup -> mount) firing this real POST twice
        if (didSubmit.current) return;
        didSubmit.current = true;

        let isMounted = true;

        const submit = async () => {
            try {
                // Step 1: create dotaznik, get id
                const createRes = await axiosPrivate.post(
                    '/cenovanabidka/dotaznik',
                    props.state.dotaznik,
                    { maxRedirects: 0 }
                );
                const id = createRes.data.id;

                // Step 2: upload files and finalize (state change + emails handled by BE)
                const formData = new FormData();
                const files = Array.from(props.state.files);
                files.forEach(file => {
                    formData.append('files', new File([file], file.name.normalize()));
                    formData.append('types', file.typ || 'dokumentace');
                });

                await axiosPrivate.post(
                    `/cenovanabidka/dotaznik/${id}/odeslat`,
                    formData,
                    {
                        headers: { 'Content-Type': 'multipart/form-data' },
                        maxRedirects: 0
                    }
                );

                // GTM tracking (SK only)
                if (process.env.REACT_APP_LANG === 'sk') {
                    window.dataLayer = window.dataLayer || [];
                    const marketingCookie = document.cookie.split('; ').find(r => r.startsWith('BmiczCookieConsent='));
                    const hasMarketing = marketingCookie ? decodeURIComponent(marketingCookie).includes('C0004:1') : false;
                    window.dataLayer.push({
                        event: 'form_submission_success',
                        customerType: props.state.dotaznik.kontakt.typZadavatele,
                        ...(hasMarketing && { email: props.state.dotaznik.kontakt.email }),
                    });
                }

                if (isMounted) props.handler(true, 'created');

                if (/^\d+$/.test(String(id))) {
                    document.location = process.env.REACT_APP_ODPOVED_URL + id;
                }
            } catch (err) {
                props.handler(false, 'createError', err.response?.data ?? {});
            }
        };

        submit();

        return () => { isMounted = false; };
    }, []);
};
